export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://api.ccdgetedcommunity.et/api";

// Image uploads come from API server root
export const BASE_URL =
  process.env.REACT_APP_API_ROOT || "https://api.ccdgetedcommunity.et";

// Frontend server URL
export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "https://ccdgetedcommunity.et";

// Admin & Resident paths
export const ADMIN_BASE =
  process.env.REACT_APP_ADMIN_BASE || "/admin/d4f9a8b2c1e7";

export const RESIDENT_BASE =
  process.env.REACT_APP_RESIDENT_BASE || "/resident";
